<abp-card class="zn-crud-page">
  <abp-card-body>
    <app-crud-page
      #crudPage
      [tableName]="config.localizationKey"
      [permission]="config.permission"
      [actions]="actions"
      [fields]="fields"
      [dataset]="dataset()"
      [loading]="loading()"
      [loadData]="loadData"
      [showEditColumn]="false"
      [hideCreateButton]="true"
      [disableEdit]="true"
      [disableEditInline]="true"
      [disableCanDelete]="true"
      [disableDuplicate]="true"
      [rowActionConfig]="rowActionConfig"
      (createRecord)="create()"
      (deleteRecord)="deleteRecords()"
      (editRow)="edit($event)"
      (rowAction)="onRowAction($event)"
      (saveInMemoryRequested)="onSaveInMemory($event)"
      (selectedItemsChange)="onRowSelection($event)"
      [exportInProgress]="exporting()"
      (exportToExcelRecord)="exportToExcel()"
    >
      <ng-template #tableHeaderActions>
        <div class="form-control-container">
          <label class="form-label" for="stand-history-stand-filter">
            {{ 'Geographic::Entity.StandTransformationHistory.StandFilter' | abpLocalization }}
          </label>

          <zn-multi-select
            id="stand-history-stand-filter"
            [optionsLoader]="standFilterOptionsLoader"
            [showSearch]="true"
            [showClearSelection]="false"
            [deferSelection]="true"
            [showPlaceholder]="false"
            [emptyDisplayValue]="'LanguageService::ZnAll'"
            [ngModel]="selectedStandIds()"
            (ngModelChange)="onSelectedStandIdsChange($event)"
          ></zn-multi-select>
        </div>
      </ng-template>
    </app-crud-page>
  </abp-card-body>
</abp-card>

<app-generic-form
  #genericForm
  (payload)="save($event)"
></app-generic-form>
